import './Page.css'

import React from "react";

export default function PageLayout({children}) {
    return (
        <div id='page-layout'>
            {children}
        </div>
    )
}